import {
  GET_WW_BULK_REQUEST,
  GET_WW_BULK_SUCCESS,
  GET_WW_BULK_ERROR,
} from "../actions/types";

export const wwBulk = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_WW_BULK_REQUEST:
      return {
        loading: true,
      };
    case GET_WW_BULK_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_WW_BULK_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};
